/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../../wire/ApiCaller";
import type { CamelToSnake } from "../../wire/transform";
import type {
  CreateLinkTypeRequest,
  CreateLinkTypeResponse,
  GetAlmItemTypeForStickyRequest,
  GetAlmItemTypeForStickyResponse,
  GetAlmItemTypeRequest,
  GetAlmItemTypeResponse,
  GetAlmTypesResponse,
  GetAlmUserResponse,
  GetIterationStatusRequest,
  GetIterationStatusResponse,
  GetKanbanConfigsRequest,
  GetKanbanConfigsResponse,
  GetProjectSourcesResponse,
  GetRallyMappingResponse,
  GetTeamFieldMappingsResponse,
  LoadAlmItemTypesRequest,
  LoadAlmItemTypesResponse,
  NoData,
  SearchAlmUsersRequest,
  SearchAlmUsersResponse,
  SetAlmTypeRequest,
  SetAlmUserRequest,
  SetRallyMappingRequest,
  SetTeamFieldMappingsRequest,
  StartIterationSyncRequest,
  StartIterationSyncResponse,
  StartProgramBacklogSyncRequest,
  StartProgramBacklogSyncResponse,
  StartSessionResponse,
  SyncStickyRequest,
} from "../models";
import {
  createLinkTypeResponseSchema,
  getAlmUserResponseSchema,
  getIterationStatusResponseSchema,
  getKanbanConfigsResponseSchema,
  getRallyMappingResponseSchema,
  getTeamFieldMappingsResponseSchema,
  loadAlmItemTypesResponseSchema,
  noDataSchema,
  searchAlmUsersResponseSchema,
  startIterationSyncResponseSchema,
  startProgramBacklogSyncResponseSchema,
  startSessionResponseSchema,
} from "../schemas";

export class AlmsyncRallyApiClient {
  constructor(private caller: ApiCaller) {}

  async start(sessionId: string, timeout?: number): Promise<StartSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.sync.start",
        variables: { sessionId: String(sessionId) },
      },
      "start",
      {},
      { schema: startSessionResponseSchema, timeout },
    );
  }

  async restart(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.sync.restart",
        variables: { sessionId: String(sessionId) },
      },
      "restart",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async forceRunning(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.sync.force.start",
        variables: { sessionId: String(sessionId) },
      },
      "forceRunning",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async setAlmType(
    payload: CamelToSnake<SetAlmTypeRequest>,
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<NoData>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.alm_type.set",
        variables: { sessionId: String(sessionId) },
      },
      "setAlmType",
      payload,
      { rawRequest: true, timeout },
    );
  }

  async getAlmTypes(
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetAlmTypesResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.alm_types.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmTypes",
      {},
      { timeout },
    );
  }

  async getAlmItemType(
    payload: GetAlmItemTypeRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetAlmItemTypeResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.alm_item_type.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmItemType",
      payload,
      { timeout },
    );
  }

  async getAlmItemTypeForSticky(
    payload: GetAlmItemTypeForStickyRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetAlmItemTypeForStickyResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.alm_item_type.for_sticky.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmItemTypeForSticky",
      payload,
      { timeout },
    );
  }

  async loadAlmItemTypes(
    payload: LoadAlmItemTypesRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<LoadAlmItemTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.connections.${connectionId}.alm_item_types.load",
        variables: { connectionId: String(connectionId) },
      },
      "loadAlmItemTypes",
      payload,
      { schema: loadAlmItemTypesResponseSchema, timeout },
    );
  }

  async createLinkType(
    payload: CreateLinkTypeRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<CreateLinkTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.link_types.create",
        variables: { sessionId: String(sessionId) },
      },
      "createLinkType",
      payload,
      { schema: createLinkTypeResponseSchema, timeout },
    );
  }

  async getRallySessionTeamFieldMappings(
    sessionId: string,
    timeout?: number,
  ): Promise<GetTeamFieldMappingsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.team_field_mappings.get",
        variables: { sessionId: String(sessionId) },
      },
      "getRallySessionTeamFieldMappings",
      {},
      { schema: getTeamFieldMappingsResponseSchema, timeout },
    );
  }

  async setRallySessionTeamFieldMappings(
    payload: SetTeamFieldMappingsRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.team_field_mappings.set",
        variables: { sessionId: String(sessionId) },
      },
      "setRallySessionTeamFieldMappings",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getIterationStatus(
    payload: GetIterationStatusRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetIterationStatusResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.iterations_sync.get",
        variables: { sessionId: String(sessionId) },
      },
      "getIterationStatus",
      payload,
      { schema: getIterationStatusResponseSchema, timeout },
    );
  }

  async startIterationsSync(
    payload: StartIterationSyncRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<StartIterationSyncResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.iterations_sync.start",
        variables: { sessionId: String(sessionId) },
      },
      "startIterationsSync",
      payload,
      { schema: startIterationSyncResponseSchema, timeout },
    );
  }

  async startSyncProgramBacklog(
    payload: StartProgramBacklogSyncRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<StartProgramBacklogSyncResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.sync_program_backlog.start",
        variables: { sessionId: String(sessionId) },
      },
      "startSyncProgramBacklog",
      payload,
      { schema: startProgramBacklogSyncResponseSchema, timeout },
    );
  }

  async getAlmUsers(
    payload: SearchAlmUsersRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<SearchAlmUsersResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.alm_users.get",
        variables: { sessionId: String(sessionId) },
      },
      "getAlmUsers",
      payload,
      { schema: searchAlmUsersResponseSchema, timeout },
    );
  }

  async setAlmUser(
    payload: SetAlmUserRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.alm_users.create",
        variables: { sessionId: String(sessionId) },
      },
      "setAlmUser",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAlmUser(connectionId: string, timeout?: number): Promise<GetAlmUserResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.connections.${connectionId}.user.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAlmUser",
      {},
      { schema: getAlmUserResponseSchema, timeout },
    );
  }

  async getProjectSources(
    connectionId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetProjectSourcesResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.connections.${connectionId}.project_sources.get",
        variables: { connectionId: String(connectionId) },
      },
      "getProjectSources",
      {},
      { timeout },
    );
  }

  async getKanbanConfigs(
    payload: GetKanbanConfigsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetKanbanConfigsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.connections.${connectionId}.kanban_configs.get",
        variables: { connectionId: String(connectionId) },
      },
      "getKanbanConfigs",
      payload,
      { schema: getKanbanConfigsResponseSchema, timeout },
    );
  }

  async getMapping(sessionId: string, timeout?: number): Promise<GetRallyMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.sprint_mappings.get",
        variables: { sessionId: String(sessionId) },
      },
      "getMapping",
      {},
      { schema: getRallyMappingResponseSchema, timeout },
    );
  }

  async setMapping(
    payload: SetRallyMappingRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.sprint_mappings.set",
        variables: { sessionId: String(sessionId) },
      },
      "setMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async syncSticky(
    payload: SyncStickyRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.rally.sessions.${sessionId}.sticky.sync",
        variables: { sessionId: String(sessionId) },
      },
      "syncSticky",
      payload,
      { schema: noDataSchema, timeout },
    );
  }
}
